/**
 * TUUFAM LUXURY STREETWEAR & HARDWARE GALLERY ENGINE (MOBILE)
 * ─────────────────────────────────────────────────────────────
 * ✓ Full-Bleed 2:3 Immersive Touch Canvas
 * ✓ TUUFAM Tactical Liquid Glass Floating Segment Console
 * ✓ 100% Vibrant Thumbnails with Auto-Switching
 * ✓ TUUFAM Bottom-Sheet Fit Guide with Live [ IN | CM ] Switcher
 * ─────────────────────────────────────────────────────────────
 */
(() => {
  if (window.innerWidth > 989) return; // Mobile only

  let globalActiveIndex = 0;
  let maleMedia = [];
  let femaleMedia = [];
  let detailMedia = [];
  let activeGenderFilter = 'all'; // 'all', 'him', 'her'

  let leftDir = 1;
  let rightDir = -1;
  let isTouching = false;
  let animationFrameId = null;
  let leftScrollPos = 0;
  let rightScrollPos = 0;
  const scrollSpeed = 0.35;

  // --- PERSISTENT MOBILE REEL ANIMATION ---
  const startMobileReelAnimation = () => {
    if (animationFrameId) cancelAnimationFrame(animationFrameId);

    const step = () => {
      if (activeGenderFilter === 'all' && !isTouching) {
        const leftC = document.querySelector('.tf-gallery-thumb-left');
        const rightC = document.querySelector('.tf-gallery-thumb-right');

        if (leftC && leftC.scrollHeight > leftC.clientHeight) {
          leftScrollPos += scrollSpeed * leftDir;
          const maxLeft = leftC.scrollHeight - leftC.clientHeight;
          if (leftScrollPos <= 0) { leftDir = 1; leftScrollPos = 0; }
          if (leftScrollPos >= maxLeft) { leftDir = -1; leftScrollPos = maxLeft; }
          leftC.scrollTop = leftScrollPos;
        }

        if (rightC && rightC.scrollHeight > rightC.clientHeight) {
          rightScrollPos += scrollSpeed * rightDir;
          const maxRight = rightC.scrollHeight - rightC.clientHeight;
          if (rightScrollPos <= 0) { rightDir = 1; rightScrollPos = 0; }
          if (rightScrollPos >= maxRight) { rightDir = -1; rightScrollPos = maxRight; }
          rightC.scrollTop = rightScrollPos;
        }
      }
      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);
  };

  const parseMobileProductImages = (mediaStack) => {
    if (maleMedia.length > 0 || femaleMedia.length > 0) return;

    const rawImages = mediaStack.querySelectorAll(':scope > img');
    rawImages.forEach((img) => {
      const src = img.getAttribute('src') || '';
      const alt = (img.getAttribute('alt') || '').trim().toLowerCase();
      const srcLower = src.toLowerCase();

      if (
        srcLower.includes('-m-') ||
        srcLower.includes('ow-m') ||
        srcLower.includes('pb-m') ||
        srcLower.includes('pl-m') ||
        alt.includes('male') ||
        alt.includes('men')
      ) {
        maleMedia.push({ src, alt, category: 'him' });
      } else if (
        srcLower.includes('-f-') ||
        srcLower.includes('ow-f') ||
        srcLower.includes('pb-f') ||
        srcLower.includes('pl-f') ||
        alt.includes('female') ||
        alt.includes('women')
      ) {
        femaleMedia.push({ src, alt, category: 'her' });
      } else {
        detailMedia.push({ src, alt, category: 'detail' });
      }
    });

    if (detailMedia.length === 0 && maleMedia.length > 0) {
      detailMedia.push(maleMedia[0]);
    }
  };

  const getActiveMobileList = () => {
    if (activeGenderFilter === 'him') return maleMedia;
    if (activeGenderFilter === 'her') return femaleMedia;
    return detailMedia;
  };

  const rebuildMobileGallery = () => {
    const mediaStack = document.querySelector('.tuufam-desktop-media-stack');
    if (!mediaStack) return;

    parseMobileProductImages(mediaStack);

    // Clean up
    const parent = mediaStack.parentNode;
    const oldFilter = parent.querySelector('.tuufam-model-filter-bar');
    if (oldFilter) oldFilter.remove();
    const oldLeftThumbs = mediaStack.querySelector('.tf-gallery-thumb-left');
    const oldRightThumbs = mediaStack.querySelector('.tf-gallery-thumb-right');
    const oldViewport = mediaStack.querySelector('.tf-gallery-main-viewport');
    if (oldLeftThumbs) oldLeftThumbs.remove();
    if (oldRightThumbs) oldRightThumbs.remove();
    if (oldViewport) oldViewport.remove();

    // 1. BUILD STAGE LAYOUT
    if (activeGenderFilter === 'all') {
      mediaStack.classList.remove('tf-single-view-mode');

      // LEFT REEL: MALE PHOTOS
      const leftThumbContainer = document.createElement('div');
      leftThumbContainer.className = 'tf-gallery-thumb-container tf-gallery-thumb-left';
      leftThumbContainer.addEventListener('touchstart', () => (isTouching = true), { passive: true });
      leftThumbContainer.addEventListener('touchend', () => (isTouching = false), { passive: true });

      const repeatCount = 3;
      for (let r = 0; r < repeatCount; r++) {
        maleMedia.forEach((mediaItem, idx) => {
          const thumbImg = document.createElement('img');
          thumbImg.src = mediaItem.src;
          thumbImg.className = 'tf-gallery-thumb-item tf-thumb-male';
          thumbImg.addEventListener('click', () => {
            activeGenderFilter = 'him';
            globalActiveIndex = idx;
            rebuildMobileGallery();
          });
          leftThumbContainer.appendChild(thumbImg);
        });
      }

      // RIGHT REEL: FEMALE PHOTOS
      const rightThumbContainer = document.createElement('div');
      rightThumbContainer.className = 'tf-gallery-thumb-container tf-gallery-thumb-right';
      rightThumbContainer.addEventListener('touchstart', () => (isTouching = true), { passive: true });
      rightThumbContainer.addEventListener('touchend', () => (isTouching = false), { passive: true });

      for (let r = 0; r < repeatCount; r++) {
        femaleMedia.forEach((mediaItem, idx) => {
          const thumbImg = document.createElement('img');
          thumbImg.src = mediaItem.src;
          thumbImg.className = 'tf-gallery-thumb-item tf-thumb-female';
          thumbImg.addEventListener('click', () => {
            activeGenderFilter = 'her';
            globalActiveIndex = idx;
            rebuildMobileGallery();
          });
          rightThumbContainer.appendChild(thumbImg);
        });
      }

      // CENTER VIEWPORT: DETAIL SHOTS
      const mainViewport = document.createElement('div');
      mainViewport.className = 'tf-gallery-main-viewport';

      const mainImg = document.createElement('img');
      mainImg.className = 'tf-gallery-main-image';
      mainImg.src = detailMedia[globalActiveIndex] ? detailMedia[globalActiveIndex].src : (maleMedia[0] ? maleMedia[0].src : '');
      mainViewport.appendChild(mainImg);

      const counterPill = document.createElement('div');
      counterPill.className = 'tf-mobile-counter-pill';
      counterPill.textContent = `${globalActiveIndex + 1} / ${detailMedia.length}`;
      mainViewport.appendChild(counterPill);

      const prevBtn = document.createElement('div');
      prevBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-prev';
      prevBtn.innerHTML = '&#10216;';
      prevBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextMobileImage(-1); });

      const nextBtn = document.createElement('div');
      nextBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-next';
      nextBtn.innerHTML = '&#10217;';
      nextBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextMobileImage(1); });

      mainViewport.appendChild(prevBtn);
      mainViewport.appendChild(nextBtn);

      setupTouchSwiper(mainViewport);

      mediaStack.appendChild(leftThumbContainer);
      mediaStack.appendChild(mainViewport);
      mediaStack.appendChild(rightThumbContainer);
    } else {
      // SINGLE GENDER VIEW
      mediaStack.classList.add('tf-single-view-mode');
      const currentList = getActiveMobileList();

      const mainViewport = document.createElement('div');
      mainViewport.className = 'tf-gallery-main-viewport';

      const mainImg = document.createElement('img');
      mainImg.className = 'tf-gallery-main-image';
      mainImg.src = currentList[globalActiveIndex] ? currentList[globalActiveIndex].src : '';
      mainViewport.appendChild(mainImg);

      const counterPill = document.createElement('div');
      counterPill.className = 'tf-mobile-counter-pill';
      counterPill.textContent = `${globalActiveIndex + 1} / ${currentList.length}`;
      mainViewport.appendChild(counterPill);

      const prevBtn = document.createElement('div');
      prevBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-prev';
      prevBtn.innerHTML = '&#10216;';
      prevBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextMobileImage(-1); });

      const nextBtn = document.createElement('div');
      nextBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-next';
      nextBtn.innerHTML = '&#10217;';
      nextBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextMobileImage(1); });

      mainViewport.appendChild(prevBtn);
      mainViewport.appendChild(nextBtn);

      setupTouchSwiper(mainViewport);
      mediaStack.appendChild(mainViewport);
    }

    // 2. INJECT TUUFAM FLOATING SEGMENT BAR
    const filterBar = document.createElement('div');
    filterBar.className = 'tuufam-model-filter-bar tf-mobile-filter';
    filterBar.innerHTML = `
      <button type="button" class="tf-filter-pill tf-filter-him ${activeGenderFilter === 'him' ? 'is-active' : ''}" data-filter="him">
        <span class="tf-dot-him"></span> ON HIM
      </button>
      <button type="button" class="tf-filter-pill tf-filter-all ${activeGenderFilter === 'all' ? 'is-active' : ''}" data-filter="all">
        ALL LOOKS
      </button>
      <button type="button" class="tf-filter-pill tf-filter-her ${activeGenderFilter === 'her' ? 'is-active' : ''}" data-filter="her">
        <span class="tf-dot-her"></span> ON HER
      </button>
    `;

    filterBar.querySelectorAll('.tf-filter-pill').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        activeGenderFilter = btn.dataset.filter;
        globalActiveIndex = 0;
        rebuildMobileGallery();
      });
    });

    mediaStack.parentNode.insertBefore(filterBar, mediaStack.nextSibling);

    startMobileReelAnimation();
  };

  const setupTouchSwiper = (viewport) => {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    const swipeThreshold = 45;

    viewport.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    viewport.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;

      const diffX = touchEndX - touchStartX;
      const diffY = touchEndY - touchStartY;

      // Only trigger horizontal photo change if user clearly swiped left/right (never blocks vertical scroll)
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > swipeThreshold) {
        if (diffX < 0) findNextMobileImage(1);
        if (diffX > 0) findNextMobileImage(-1);
      }
    }, { passive: true });
  };

  const findNextMobileImage = (direction) => {
    const currentList = getActiveMobileList();
    if (!currentList.length) return;
    globalActiveIndex = (globalActiveIndex + direction + currentList.length) % currentList.length;
    updateMobileDisplayState();
  };

  const updateMobileDisplayState = () => {
    const mediaStack = document.querySelector('.tuufam-desktop-media-stack');
    const currentList = getActiveMobileList();
    if (!mediaStack || !currentList.length) return;

    const mainImg = mediaStack.querySelector('.tf-gallery-main-image');
    if (mainImg && currentList[globalActiveIndex]) {
      mainImg.src = currentList[globalActiveIndex].src;
    }

    const counterPill = mediaStack.querySelector('.tf-mobile-counter-pill');
    if (counterPill) {
      counterPill.textContent = `${globalActiveIndex + 1} / ${currentList.length}`;
    }
  };

  // --- ALTERNATING COUPON GLOW ---
  const initCouponBreathing = () => {
    const cards = document.querySelectorAll('.tuufam-coupon-card');
    if (cards.length < 2) return;

    let activeCard = 0;
    setInterval(() => {
      cards.forEach((card, idx) => {
        card.classList.toggle('tf-coupon-active', idx === activeCard);
      });
      activeCard = (activeCard + 1) % cards.length;
    }, 2200);
  };

  // --- ACCORDION MUTEX ---
  const initMobileAccordions = () => {
    const accordions = document.querySelectorAll('.tuufam-accordion-item');
    accordions.forEach((targetDetail) => {
      targetDetail.addEventListener('toggle', () => {
        if (targetDetail.open) {
          accordions.forEach((otherDetail) => {
            if (otherDetail !== targetDetail && otherDetail.open) otherDetail.open = false;
          });
        }
      });
    });
  };

  // --- REAL-TIME LIVE STOCK & TACTILE SIZE ENGINE (MOBILE) ---
  const initMobileSizeAndStockTracker = () => {
    const updateMobileInventoryDisplay = () => {
      const inventoryEl = document.querySelector('.product__inventory');
      if (!inventoryEl) return;

      const text = (inventoryEl.textContent || '').toLowerCase();
      const numMatch = text.match(/\d+/);
      const qty = numMatch ? parseInt(numMatch[0], 10) : 0;

      if (text.includes('low') || text.includes('left') || (qty > 0 && qty <= 3)) {
        inventoryEl.innerHTML = `
          <span class="tf-radar-pulse tf-radar-amber"></span>
          <span class="tf-stock-text">LOW STOCK · ONLY ${qty > 0 ? qty : 2} COMBOS LEFT (BATCH 01)</span>
        `;
      } else if (text.includes('out of stock') || text.includes('sold out')) {
        inventoryEl.innerHTML = `
          <span class="tf-radar-pulse tf-radar-muted"></span>
          <span class="tf-stock-text">SIZE SOLD OUT · JOIN RESTOCK NOTIFY</span>
        `;
      } else {
        inventoryEl.innerHTML = `
          <span class="tf-radar-pulse tf-radar-emerald"></span>
          <span class="tf-stock-text">BATCH 01 · READY FOR EXPRESS DISPATCH</span>
        `;
      }
    };

    document.querySelectorAll('.product-form__input input[type="radio"], variant-radios input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        setTimeout(updateMobileInventoryDisplay, 150);
      });
    });

    updateMobileInventoryDisplay();
  };

  // --- TUUFAM BOTTOM SHEET FIT GUIDE & UNIT SWITCHER LOGIC ---
  const initFitGuideEngine = () => {
    const modal = document.getElementById('tuufam-size-modal');
    const openBtns = document.querySelectorAll('.tf-fit-guide-btn, [data-open-size-chart], .product-popup-modal__opener, .product-form__input .form__label button, [href="#size-chart"]');
    if (!modal) return;

    const closeBtn = modal.querySelector('.tuufam-modal-close-btn');
    const unitBtns = modal.querySelectorAll('.tf-unit-btn');
    const tableRows = modal.querySelectorAll('.tuufam-size-table tbody tr');

    const openModal = (e) => {
      if (e) e.preventDefault();
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    };

    openBtns.forEach((btn) => btn.addEventListener('click', openModal));
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // Unit Switcher (IN vs CM)
    unitBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        unitBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const unit = btn.dataset.unit;
        modal.querySelectorAll('.tf-unit-label').forEach((el) => (el.textContent = unit.toUpperCase()));

        tableRows.forEach((row) => {
          const values = (row.dataset[unit] || '').split(',');
          if (values.length === 3) {
            row.querySelector('.tf-c').textContent = values[0];
            row.querySelector('.tf-l').textContent = values[1];
            row.querySelector('.tf-s').textContent = values[2];
          }
        });
      });
    });
  };

  // --- BULLETPROOF RAZORPAY & MOBILE STICKY CART QUANTITY ENGINE ---
  const initMobileCartQuantitySync = () => {
    const getQty = () => {
      const qtyInput = document.querySelector('.quantity__input');
      return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    };

    const ensureHiddenInputInForms = () => {
      const currentQty = getQty();
      document.querySelectorAll('form[action*="/cart/add"], form[id^="product-form-"]').forEach((form) => {
        let hiddenQty = form.querySelector('input[name="quantity"]');
        if (!hiddenQty) {
          hiddenQty = document.createElement('input');
          hiddenQty.type = 'hidden';
          hiddenQty.name = 'quantity';
          form.appendChild(hiddenQty);
        }
        hiddenQty.value = currentQty;
      });
    };

    ensureHiddenInputInForms();

    const qtyInput = document.querySelector('.quantity__input');
    if (qtyInput) {
      qtyInput.addEventListener('change', ensureHiddenInputInForms);
      qtyInput.addEventListener('input', ensureHiddenInputInForms);
    }

    // Capture-phase priority intercept: Updates form BEFORE checkout reads it
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button, a, [role="button"], .product-form__submit, [name="add"], .tf-mobile-sticky-btn, [data-razorpay-checkout]');
      if (btn) {
        ensureHiddenInputInForms();
      }
    }, true);
  };

  document.addEventListener('DOMContentLoaded', () => {
    rebuildMobileGallery();
    initMobileAccordions();
    initCouponBreathing();
    initMobileSizeAndStockTracker();
    initFitGuideEngine();
    initMobileCartQuantitySync();
  });
})();